export default {
  "help": {
    "popup": {
      "title": {
        "newhand": "新手入門？多種渠道幫助您了解朵頤！",
        "label": "遇到問題了？多種渠道為您解決！"
      },
      "phone": {
        "time": "服務時間：9:00－16:00",
        "desc": "更好更快的貼心服務熱線",
        "number": "服務電話：＋86 27－8282 2869",
        "label": "電話服務熱線"
      },
      "helpcenter": {
        "time": "服務時間：24小時",
        "desc": "24小時可查閱，包括朵頤使用說明以及常見問題",
        "label": "朵頤幫助中心"
      },
      "webchat": {
        "time": "服務時間：9:00－16:00",
        "desc": "在線為您解決問題，幫你節省各種電話費，您的服務首選",
        "label": "在線服務"
      },
      "enquirenow": "立即咨詢 >"
    }
  },
  "logout": "退出系統",
  "webpos": {
    "offline": "斷網"
  },
  "reserve": {
    "popup": {
      "noThanks": "不，下次吧",
      "title": "請選擇你想預約咨詢的時間",
      "reserve": {
        "range": "您可以預約到最近5天",
        "informWay": {
          "phone": "電話",
          "email": "註冊郵箱"
        },
        "choose": {
          "informWay": "選擇通知方式"
        }
      },
      "sure": "確認預約"
    }
  },
  "restaurant": {
    "setting": "餐館設置"
  },
  "consult": {
    "popup": {
      "noThanks": "暫時不使用，謝謝",
      "title": "您已獲取朵頤團隊30分鐘免費線上技術咨詢!",
      "reserveConsultTime": "預約咨詢時間",
      "chatOnline": "與線上客服安排時間",
      "technical": {
        "installationAndUse": "安裝指導與使用答疑",
        "support": "您將從朵頤技術團隊中獲取以下技術支持:",
        "aboutSystem": "幫助我更好了解系統去適應使用",
        "featuresAndBuy": "功能介紹與購買咨詢"
      }
    }
  },
  "pos": {
    "booking": {
      "search": "請輸入訂位序號",
      "failed": "很抱歉, 沒有找到訂位序號: __orderNo__",
      "confirm": "請確定您要綁定 __name__ (__phone__) __count__位在__date__的預訂嗎?",
      "display": "__orderNo__: __name__ (__phone__) __count__位"
    },
    "search": "查找",
    "network": {
      "slow": "網速有點緩慢，請稍後",
      "dead": "網絡異常",
      "checking": "正在檢查網絡...",
      "done": "網絡正常，請耐心等待",
      "failed": "網絡異常，請檢查網絡然後點擊“刷新”",
      "refresh": "刷新"
    },
    "reload": "請勿在離線模式下刷新，否則會丟失當前數據！",
    "error": "系統暫時無法加載，請按OK再試！",
    "bill": {
      "status": {
        "label": "帳單狀態"
      }
    },
    "generate": {
      "demo": {
        "data": "生成演示數據"
      }
    },
    "save": "保存",
    "status": {
      "paid": "已付款",
      "closed": "(空桌)",
      "unpaid": "未付款",
      "all": "全部餐桌",
      "mobile": {
        "order": "移動點單"
      }
    },
    "screensize": {
      "caution": "注意"
    },
    "menu": {
      "item": {
        "short": {
          "code": "快捷碼"
        }
      }
    },
    "settings": {
      "member": "會員管理",
      "sales": "營業記錄",
      "menu": "菜單設置",
      "table": "餐桌設置",
      "restaurant": "餐館設置",
      "license": "付款信息",
      "user": "員工管理",
      "print": "打印機設置",
      "discount": "折扣設置"
    },
    "back": {
      "to": {
        "settings": "返回設置首頁"
      }
    },
    "label": {
      "table": {
        "switch": "轉台",
        "close": "清台"
      }
    },
    "table": {
      "item": {
        "billList": "",
        "status": "餐品狀態",
        "refund": "退菜"
      },
      "modal": {
        "billItems": "訂單餐品"
      }
    },
    "analytics": {
      "data": "運營分析"
    },
    "header": {
      "queue": "",
      "booking": "",
      "help": "幫助中心",
      "weixin": "微信餐廳",
      "overview": "餐桌",
      "order": "點餐",
      "stats": "營收",
      "settings": "系统設置",
      "activity": "活动",
      "license": "許可購買",
      "cashier": "結帳",
      "online": {
        "order": "網路訂單"
      }
    },
    "printer": {
      "open": "打印插件已開啟7",
      "status": "打印機狀態",
      "unconfig": "尚未配置打印機",
      "receipt": {
        "diner": {
          "total": {
            "count": {
              "label": "用餐人數"
            }
          }
        }
      },
      "offline": "請打開打印軟件Tooie Printer",
      "close": "打印插件未開啟"
    },
    "setting": {
      "needRefresh": "请点击刷新",
      "settingSaved": "设置已保存"
    },
    "order": {
      "submit": "下單",
      "bill": {
        "total": {
          "amount": "帳單金額"
        }
      },
      "table": {
        "select": "選擇餐桌"
      },
      "confirm": {
        "yes": "OK"
      }
    },
    "experience": {
      "restaurant": {
        "alert": "您正在使用體驗餐廳! 請點擊註冊您自己的餐廳.",
        "alertshort": "點擊註冊您的餐廳."
      }
    },
    "confirm": "確認",
    "activity": {
      "menu": "體驗新功能",
      "feature": {
        "weixin": "微信餐廳",
        "analytics": "運營分析"
      },
      "join": "領取許可",
      "day": "天",
      "license": "免費體驗許可"
    },
    "cashier": {
      "add": {
        "note": "添加備註",
        "booking": "綁定訂位信息"
      },
      "choose": {
        "waiter": "選擇服務員"
      },
      "addnote": {
        "placeholder": "請輸入備註信息"
      }
    },
    "mobile": {
      "order": {
        "experience": {
          "restaurant": {
            "register": "立即註冊",
            "alert": "體驗餐廳不提供此功能, 請註冊您自己的餐廳後再使用此功能."
          }
        },
        "hint": "生成二維碼手機掃描進入移動點單"
      },
      "create": "生成"
    },
    "webchat": {
      "zopim": {
        "title": "點一點這裡就可以跟客服聊天!"
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/locales/zh-TW/translation.js